export enum NotificationType {
    SOCIAL = 'Social',
    UNREAL_ENGINE = 'UnrealEngine',
    DOWNLOADS = 'Downloads',
    SELF_UPDATE = 'SelfUpdate',
    GAME_LIBRARY = 'GameLibrary'
}

export default NotificationType;
